import React from 'react'
import './style.css'

const Movie = () => {

    const overFx = (e) => {
        let idName = e.target.parentNode.id
        document.getElementById(idName).style.opacity = 1
    }

    const leaveFx = (e) => {
        let idName = e.target.parentNode.id
        document.getElementById(idName).style.opacity = 0.3
    }

    const bgStyle = {
        backgroundImage: 'url("/movie.jpg")',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'cover',
        height: '100vh',
        overflow: 'hidden'
    }

    const movieUrl = [ 
        {url : 'ZtMm0swu5i8?rel=0&amp;showinfo=0', desc : 'I still have a soul'},      
        {url : 'pzmI3vAIhbE?rel=0&amp;showinfo=0', desc : ' Genghis Khan'},
        {url : 'erTgzZPW94I?rel=0&amp;showinfo=0', desc : 'MGS'},
        {url : 'bgTEVRSXe_4?rel=0&amp;showinfo=0', desc : 'Arranged Marriage'}
    ]

    let MovieList = movieUrl.map((poo, index) => {

        const iframeUrl = 'https://www.youtube.com/embed/' + poo.url
        const idName = 'mov' + index
        const title = poo.desc

            return (

                <div id={idName} className='MovieContainer' onMouseOver={ overFx } onMouseOut={ leaveFx }>
                    <iframe src={iframeUrl} frameborder='0' allowfullscreen='true' title={title} />
                </div>
            )
    })


    return (

        <div className='WideBanner' style={bgStyle}>

            {MovieList}

        </div>

    )
}

export default Movie



// WEBPACK FOOTER //
// ./src/components/movie/index.js